






import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: { Modal: () => import('@/components/common/modals/Modal.vue') }
})
export default class DataInsertModal extends Vue {}
